<template>
  <div class="flex flex-col mb-6">
    <label
      v-if="label"
      :for="'form-field-' + uid"
      class="mb-2"
      v-text="label"
    />
    <input
      :id="'form-field-' + uid"
      :type="type"
      class="bg-gray-200 py-2 px-4 rounded outline-none focus:bg-white focus:shadow-outline"
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      @blur="blur"
    />
    <p
      v-if="suggestion"
      class="mt-2 text-blue-400 cursor-pointer text-right"
      @click="fixEmail"
    >
      Did you mean <span class="font-bold" v-text="suggestion.full" />?
    </p>
    <password-strength v-if="showStrength" :value="value" />
    <p v-if="errors.length > 0" class="mt-2 text-red-400" v-text="errors[0]" />
  </div>
</template>

<script>
import PasswordStrength from '~/components/PasswordStrength.vue'
const mailcheck = require('mailcheck')

export default {
  components: {
    PasswordStrength
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    errors: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showStrength: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      suggestion: false
    }
  },
  computed: {
    uid() {
      return this._uid
    }
  },
  methods: {
    blur() {
      if (this.type === 'email') {
        this.checkEmail()
      }
    },
    checkEmail() {
      mailcheck.run({
        email: this.value,
        suggested: (suggestion) => {
          this.suggestion = suggestion
        },
        empty: () => {
          this.suggestion = false
        }
      })
    },
    fixEmail() {
      this.$emit('input', this.suggestion.full)
      this.suggestion = false
    }
  }
}
</script>
